import React from "react";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as categoryRedux from "modules/Category/_redux/categoryRedux";
import "./sahibindenFilters.css";

// Kat sayısı aralığı (m² ile aynı konvansiyon).
// selectedFilter.minMaxKatSayisi = [min, max]; backend plugin'i seller katSayisi
// field'ı üzerinde { $gte, $lte } ile uygular.
function SLMinMaxKatSayisi(props) {
  const { selectedFilter } = useSelector(
    (state) => ({ selectedFilter: state.category.selectedFilter }),
    shallowEqual
  );

  const value = selectedFilter?.minMaxKatSayisi || ["", ""];
  const [min, max] = value;

  const setRange = (nextMin, nextMax) => {
    const empty =
      (nextMin === "" || nextMin === null || nextMin === undefined) &&
      (nextMax === "" || nextMax === null || nextMax === undefined);
    if (empty) {
      props.removeFilter({ parent: "minMaxKatSayisi" });
      return;
    }
    props.addFilterBulk({ parent: "minMaxKatSayisi", value: [nextMin, nextMax] });
  };

  return (
    <section id={props.filter.id} className="sf-section">
      <div className="sf-title">{props.filter.title || "Kat Sayısı"}</div>
      <div className="sf-minmax">
        <input
          className="sf-input"
          type="number"
          placeholder="min"
          value={min == null ? "" : min}
          onChange={(e) =>
            setRange(e.target.value === "" ? "" : Number(e.target.value), max)
          }
        />
        <span className="sf-dash">–</span>
        <input
          className="sf-input"
          type="number"
          placeholder="max"
          value={max == null ? "" : max}
          onChange={(e) =>
            setRange(min, e.target.value === "" ? "" : Number(e.target.value))
          }
        />
      </div>
    </section>
  );
}

export default connect(null, { ...categoryRedux.actions })(SLMinMaxKatSayisi);
